import { useState } from "react";
import { validateDiscountCode } from "@/lib/api";

export const codeDiscountAmount = (d, subtotal) => !d ? 0 : d.type === "percent"
    ? Math.round(subtotal * Number(d.value)) / 100
    : Math.min(Number(d.value || 0), subtotal);

export const KioskPromoCode = ({ subtotal, applied, setApplied }) => {
    const [input, setInput] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);

    const apply = async () => {
        const code = input.trim().toUpperCase();
        if (!code) return;
        setBusy(true); setErr("");
        try {
            const r = await validateDiscountCode(code, subtotal, "collection");
            if (r.valid) { setApplied(r); setInput(""); } else setErr(r.reason || "That code isn't valid");
        } catch { setErr("Couldn't check the code. Try again."); }
        finally { setBusy(false); }
    };

    if (applied) return (
        <div className="flex items-center justify-between mb-6 bg-[var(--surface-elevated)] border border-[var(--gold)] px-4 py-3" data-testid="kiosk-applied-code">
            <div>
                <div className="font-mono text-[13px] text-gold">✓ {applied.code} applied</div>
                <div className="font-mono text-[11px] text-muted">
                    {applied.type === "percent" ? `${applied.value}% off` : `£${Number(applied.value).toFixed(2)} off`}
                </div>
            </div>
            <button onClick={() => setApplied(null)} className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted px-3 py-2" data-testid="kiosk-remove-code">Remove</button>
        </div>
    );

    return (
        <div className="mb-6" data-testid="kiosk-promo">
            <label className="font-mono text-[10px] uppercase tracking-[0.18em] text-muted block mb-2">Promo or voucher code</label>
            <div className="flex gap-2">
                <input className="input flex-1 uppercase" placeholder="Enter code" value={input} autoCapitalize="characters" autoCorrect="off"
                    onChange={(e) => setInput(e.target.value)} onKeyDown={(e) => e.key === "Enter" && apply()} data-testid="kiosk-code-input" />
                <button className="btn-secondary" onClick={apply} disabled={busy || !input.trim()} data-testid="kiosk-code-apply">
                    {busy ? "Checking…" : "Apply"}
                </button>
            </div>
            {err && <p className="font-mono text-[11px] text-[#ff5246] mt-2" data-testid="kiosk-code-error">{err}</p>}
        </div>
    );
};
